export default __webpack_public_path__ + "static/media/img-ln-6-ovato.9a6f2071.png";